/* TIMELESS MOONLIGHT MELTS — "Turn off the lights".

   Burner and diffuser listings are shot to a pattern: image 1 is the product in
   daylight, image 2 is the same product lit in the dark. This turns that second
   shot into the point of the page — press the button and the room goes dark
   around the product.

   TWO MODES, set by snippets/tmm-product-extras.liquid:

     product     one gallery. Driven through the Swiper instance (slideTo) so
                 the thumbnails, counter and zoom stay in step — setting the
                 <img> src by hand would desync all three.

     collection  a grid of cards, each with one image. The second image is not
                 in the DOM, so it comes from ONE fetch of the collection's
                 products.json (not one request per card), cached after the
                 first press. Cards whose product has no second image are left
                 alone rather than blanked.

   The class goes on <html> so the whole page cross-fades from one switch. It is
   never persisted — a reload brings the lights back up, which is the right
   default for someone arriving cold.
*/
(function () {
  'use strict';

  var ON_LABEL = 'Turn off the lights';
  var OFF_LABEL = 'Turn the lights on';

  var cfg = window.TMM_LIGHTS;
  if (!cfg || !cfg.enabled) return;

  /* ---- shared ----------------------------------------------------------- */

  function makeButton() {
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'tmm-lights';
    btn.setAttribute('aria-pressed', 'false');
    btn.innerHTML =
      '<span class="tmm-lights__dot" aria-hidden="true"></span>' +
      '<span class="tmm-lights__label">' + ON_LABEL + '</span>';
    return btn;
  }

  /* The tab is position: fixed, so it goes straight on <body>. Nesting it in
     the gallery or the grid would let any ancestor transform or overflow clip
     it — both are common in this theme. */
  function place(btn) {
    var wrap = document.createElement('div');
    wrap.className = 'tmm-lights-wrap';
    wrap.appendChild(btn);
    document.body.appendChild(wrap);
    return wrap;
  }

  function setLabel(btn, out) {
    btn.querySelector('.tmm-lights__label').textContent = out ? OFF_LABEL : ON_LABEL;
    btn.setAttribute('aria-pressed', String(out));
  }

  /* Keep the CDN transform the card was already using, so turning the lights
     off does not quietly download a full-size original for every tile. */
  function sized(url, likeImg) {
    var current = (likeImg && (likeImg.currentSrc || likeImg.src)) || '';
    var m = current.match(/[?&]width=(\d+)/);
    var w = m ? m[1] : '600';
    return url + (url.indexOf('?') === -1 ? '?' : '&') + 'width=' + w;
  }

  /* ---- product page ----------------------------------------------------- */

  function mainGallery() {
    var all = [].slice.call(document.querySelectorAll('.swiper'));
    for (var i = 0; i < all.length; i++) {
      if (all[i].swiper && all[i].querySelector('img.drift-trigger')) return all[i];
    }
    return null;
  }

  function initProduct() {
    if (document.querySelector('.tmm-lights')) return true;

    var gallery = mainGallery();
    if (!gallery || !gallery.swiper || gallery.swiper.slides.length < 2) return false;

    var btn = makeButton();
    place(btn);

    btn.addEventListener('click', function () {
      var out = document.documentElement.classList.toggle('tmm-lights-out');
      try { gallery.swiper.slideTo(out ? 1 : 0); } catch (e) {}
      setLabel(btn, out);
    });
    return true;
  }

  /* ---- collection page -------------------------------------------------- */

  var darkMap = null;

  function loadDarkMap() {
    if (darkMap) return Promise.resolve(darkMap);
    var url = '/collections/' + encodeURIComponent(cfg.handle) + '/products.json?limit=250';
    return fetch(url, { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (d) {
        darkMap = {};
        (d.products || []).forEach(function (p) {
          if (p.images && p.images.length > 1) darkMap[p.handle] = p.images[1].src;
        });
        return darkMap;
      })
      .catch(function () { darkMap = {}; return darkMap; });
  }

  function handleOf(card) {
    var link = card.querySelector('a[href*="/products/"]');
    if (!link) return null;
    var href = link.getAttribute('href') || '';
    var part = href.split('/products/')[1];
    return part ? part.split('?')[0].split('#')[0] : null;
  }

  function swapCards(map, out) {
    document.querySelectorAll('.product-item').forEach(function (card) {
      var img = card.querySelector('.product__media img') || card.querySelector('img');
      if (!img) return;

      if (out) {
        var handle = handleOf(card);
        var dark = handle && map[handle];
        if (!dark) return;
        if (img.dataset.tmmLit === undefined) {
          img.dataset.tmmLit = img.getAttribute('src') || '';
          img.dataset.tmmLitSet = img.getAttribute('srcset') || '';
        }
        img.removeAttribute('srcset');
        img.src = sized(dark, img);
      } else if (img.dataset.tmmLit !== undefined) {
        img.src = img.dataset.tmmLit;
        if (img.dataset.tmmLitSet) img.setAttribute('srcset', img.dataset.tmmLitSet);
      }
    });
  }

  function initCollection() {
    if (document.querySelector('.tmm-lights')) return true;

    var firstCard = document.querySelector('.product-item');
    if (!firstCard) return false;

    /* Each card sits in its own .grid__item cell; the switch has to go before
       the GRID, not before a cell, or it becomes a card-shaped hole in row 1. */
    var cell = firstCard.closest('.grid__item') || firstCard.parentElement;
    var grid = cell && cell.parentElement;
    if (!grid || !grid.parentElement) return false;

    var btn = makeButton();
    place(btn);

    btn.addEventListener('click', function () {
      var out = document.documentElement.classList.toggle('tmm-lights-out');
      setLabel(btn, out);
      btn.disabled = true;
      loadDarkMap().then(function (map) {
        swapCards(map, out);
        btn.disabled = false;
      });
    });

    /* Filtering and pagination re-render the grid; re-apply if the lights are
       still off so newly drawn cards are not left lit. */
    new MutationObserver(function () {
      if (document.documentElement.classList.contains('tmm-lights-out') && darkMap) {
        swapCards(darkMap, true);
      }
    }).observe(grid, { childList: true });

    return true;
  }

  /* ---- boot -------------------------------------------------------------- */

  function boot() {
    var tries = 0;
    var run = cfg.mode === 'collection' ? initCollection : initProduct;
    var t = setInterval(function () {
      tries++;
      if (run() || tries > 25) clearInterval(t);
    }, 200);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
